import {Injectable} from '@angular/core';
import * as algolia from 'algoliasearch';
import {environment} from '../../../environments/environment';
import {FullUser} from '../../user/model';
import {forkJoin, Observable, Observer} from 'rxjs';
import {AngularFirestore} from '@angular/fire/firestore';
import {map, take} from 'rxjs/operators';

const client: algolia.Client = algolia(environment.algolia.applicationId,
  environment.algolia.apiKey, {
  timeout: 2000
});
const index: algolia.Index = client.initIndex('users-index');
@Injectable({providedIn: 'root'})
export class SearchService {
  constructor(private fireStore: AngularFirestore,
              ) {
  }

  public search(term: string): Observable<FullUser[]> {
    return Observable.create((observer: Observer<FullUser[]>) => {
      index.search({
          query: term,
          attributesToRetrieve: ['displayName'],
          hitsPerPage: 50,
        },
        (err, res: algolia.Response<any>) => {
          if (err) {
            observer.error(err);
          } else {
            forkJoin(
              res.hits.map(obj => {
                return obj.objectID;
              }).map(id => {
                return this.fireStore.collection('/users').doc<FullUser>(id).get().pipe(
                  map(d => d.data() as FullUser)
                );
              })).pipe(take(1)).subscribe(users => {
              observer.next(users);
              observer.complete();
            });
          }
        });
    });
  }
}
